import type { OrderItem } from "@jti/magento";

import { sortByStandaloneGifts } from "@commerce/shared";

export const getSortedCartItems = (items: OrderItem[] | undefined) => {
  if (!items || !Array.isArray(items)) {
    return [];
  }

  return [...items].sort(sortByStandaloneGifts);
};
